import App from './SteelElementApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iSteelElement', <App />);
